import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout: 20 * 1000,
});

export default instance;
